<template>
  <div
    v-can="'disable-resources'"
    class="mx-12"
  >
    <h2 v-text="'Disabled Resources'" />
    <div
      v-if="resources.length"
      class="flex flex-wrap justify-start mt-6"
    >
      <div
        v-for="resource in resources"
        :key="resource.uuid"
        :resource="resource"
      />
    </div>
    <div
      v-else
      class="text-center text-grey p-6 italic"
      v-text="'There are currently no disabled resources.'"
    />
  </div>
</template>

<script type="text/babel">
export default {
  name: 'DisabledResources',
  computed: {
    resources() {
      return this.$store.state.resource.disabledResources.data
    },
  },
  async mounted() {
    await this.$nextTick()

    this.$store.dispatch('resourceGetDisabledResources')
  },
}
</script>
